<section class="container-section" *ngIf="!isOpened">
  <div class="row">
    <form class="needs-validation container-style" novalidate [formGroup]="formMaintenanceOrder">
      <div class="ps-2 pe-2 pb-2">
        <div class="row pt-1">
          <div class="col">
            <app-custom-button [title]="'Regresar'" [icon]="'pi pi-arrow-left'" [link]="true" [label]="'Regresar'"
              [width]="'6rem'" [routerLink]="'/maintenance-order'" [severity]="null"></app-custom-button>
          </div>
          <div class="col d-flex justify-content-sm-center justify-content-end align-items-center">
            <app-navigation (buttonClick)="getButtonClick($event)"></app-navigation>
          </div>

          <div class="col mt-2 mt-sm-0 gap-1 d-flex justify-content-md-end justify-content-center">
            <!-- Adjuntar archivos -->
            <app-custom-button [title]="'Adjuntar archivos'" [icon]="'pi pi-paperclip'" [severity]="'contrast'"
              (onClick)="openAttachFile()"></app-custom-button>
            <app-custom-modal #attachFileMaintenanceOrder [header]="'Adjuntar archivos'"
              [children]="componentAttachFiles" [closable]="true" [width]="'40vw'" [inputs$]="inputsForAttachFiles$"
              [output$]="outputForAttachFiles$" hidden></app-custom-modal>

            <app-custom-button [title]="'Anular'" [icon]="'pi pi-ban'" [severity]="'contrast'"
              (onClick)="annulMaintenanceOrder()"></app-custom-button>
            <app-custom-button [title]="'Eliminar'" [icon]="'pi pi-trash'" [severity]="'contrast'"
              (onClick)="deleteMaintenanceOrder()"></app-custom-button>

            <app-custom-button class="ms-2" [title]="'Nuevo'" [label]="'Nuevo'" [icon]="'pi pi-plus'" [width]="'5.5rem'"
              [severity]="'success'" [variant]="undefined" (onClick)="createNewMaintenanceOrder()"></app-custom-button>
          </div>
          <hr class="my-1">
        </div>
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 col-12">
            <app-custom-audit-info [userNameCreate]="maintenanceOrderContract.userNameCreate"
              [createDate]="maintenanceOrderContract.createDate"
              [userNameUpdate]="maintenanceOrderContract.userNameUpdate"
              [updateDate]="maintenanceOrderContract.updateDate"
              [reserveSpace]="true"></app-custom-audit-info>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6 col-12">
            <div class="row d-flex justify-content-end">
              <div class="row col-lg-10">
                <div class="col-lg-3 col-md-3 col-sm-2 col-6">
                  <app-custom-select formControlName="branchId" [labelText]="'Sucursal'" [list]="listBranch"
                    [required]="true" [recovery]="true" (onChangeSelect)="changeBranch($event)"></app-custom-select>
                </div>
                <div class="col-lg-3 col-md-2 col-sm-3 col-6">
                  <app-custom-select formControlName="maintenanceOrderClassId" [labelText]="'Clase O.M.'"
                    [list]="listClassMaintenanceOrder" [required]="true" [recovery]="true"
                    (onChangeSelect)="changeMaintenanceOrderClass($event)"></app-custom-select>
                </div>
                <div class="col-lg-2 col-md-2 col-sm-2 col-4">
                  <app-custom-input-number id="consecutiveNumber" formControlName="consecutive" [labelText]="'Número'"
                    [required]="true" [recovery]="true"
                    (onChangeNumber)="changeConsecutive($event)"></app-custom-input-number>
                </div>
                <div class="col-lg-2 col-md-1 col-sm-2 col-3">
                  <app-custom-tag [label]="'Estado'" [value]="maintenanceOrderStateString"
                    [severity]="maintenanceOrderContract.maintenanceOrderStateId === 1 ? 'danger' : ''">
                  </app-custom-tag>
                </div>
                <div class="col-lg-2 col-md-3 col-sm-3 col-5 d-flex align-items-end gap-1">
                  <app-custom-button [title]="titleStateMaintenanceOrder" [icon]="iconStateMaintenanceOrder"
                    [disabled]="disabledChangeStateBtn" (onClick)="changeState()"></app-custom-button>
                  <app-custom-button [title]="'Reversar estado'" [icon]="'pi pi-undo'"
                    [disabled]="disabledReverseStateBtn" (onClick)="reverseState()"></app-custom-button>
                  <app-custom-checkbox formControlName="swBlock" class="sw-block" [labelText]="'Bloq.'"
                    (onChangeCheckBox)="blockMaintenanceOrder($event)"></app-custom-checkbox>
                </div>
                <div class="col-lg-2 col-md-2 col-sm-2 col-4">
                  <app-custom-input-number formControlName="alterNumber"
                    [labelText]="'Nro.Alterno'"></app-custom-input-number>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-3 col-6">
                  <app-custom-datetime-picker formControlName="dateMaintenanceOrder"
                    [labelText]="'Fecha O.M.'"></app-custom-datetime-picker>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-5 col-12">
                  <app-custom-select formControlName="maintenanceOrderTypeId" [labelText]="'Tipo O.M.'"
                    [list]="listTypeMaintenanceOrderForClass" [required]="true"
                    (onChangeSelect)="changeMaintenanceOrderType($event, false)"></app-custom-select>
                </div>
                <!-- <div class="col-lg-1 col-md-1 col-sm-1 col-2">
                  <app-custom-button [title]="'Información'" [severity]="'secondary'" [icon]="'pi pi-info-circle'"
                    (onClick)="openToggle($event)"></app-custom-button>
                  <p-popover #information>
                    <div>
                      <span>
                        <b>Prefacturación: </b>Se desbloquea cuando a la hora de darle click
                        <br> a prefacturar en algún corte sale un mensaje de error que dice "Error.
                        <br> No pude procesar. Otro usuario está procesando en este momento."
                        <br><br>
                        <b>Facturación: </b>Se desbloquea cuando a la hora de darle click a facturar
                        <br>en algún corte sale un mensaje de error que dice "Error. No pude procesar.
                        <br>Otro usuario está procesando en este momento."
                        <br><br>
                        <b>Ocupación: </b>Se desbloquea cuando a la hora de consultar el informe
                        <br>de porcentaje de ocupación sale un mensaje de error que dice "Error.
                        <br>No pude procesar. Otro usuario está procesando en este momento."
                        <br><br>
                        <b>Desbloquear Corte: </b>Desbloquea todos los cortes de la sucursal que
                        <br>se encuentren bloqueados por cualquier usuario.
                      </span>
                    </div>
                  </p-popover>
                </div> -->
                <div class="col-lg-3 col-md-3 col-sm-3 col-12">
                  <app-custom-select formControlName="workshopType" [labelText]="'Tipo Taller'"
                    [list]="listWorkshopType" [required]="true"></app-custom-select>
                </div>
                <div [hidden]="maintenanceOrderType == typeEquipmentOwnShop" class="col-lg-6 col-md-6 col-sm-6 col-12">
                  <app-custom-autocomplete formControlName="clientId" [labelText]="'Cliente'" [list]="listClient"
                    [required]="true" (onChangeSelect)="changeClient($event)"></app-custom-autocomplete>
                </div>
                <div [hidden]="maintenanceOrderType == typeEquipmentOwnShop" class="col-lg-6 col-md-6 col-sm-6 col-12">
                  <app-custom-autocomplete formControlName="costCenterId" [labelText]="'C.Costos'"
                    [list]="listCostCenter" (onChangeSelect)="changeCostCenter($event)"></app-custom-autocomplete>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                  <app-custom-inputgroup [inputValue]="articleCodeName" [labelText]="'Equipo'" [showClear]="true"
                    [iconButton]="'pi pi-external-link'" [titleButton]="'Seleccionar Equipo'" [required]="true"
                    [disabled]="articleDisabled" (onClick)="openEquipmentSelectionModal()"
                    (valueChange)="onArticleValueChange($event)"></app-custom-inputgroup>
                  <app-custom-modal #selectEquipment [label]="'Seleccionar'" [header]="'Selección de Equipos'"
                    [children]="componentEquipmentSelection" [inputs$]="inputsForSelectEquipmentModal$"
                    [output$]="output$" (selectedItems)="setArticleStore($event)" hidden></app-custom-modal>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                  <app-custom-input-text [value]="storeCodeName" [labelText]="'Bodega'" [required]="true"
                    [disabled]="true"></app-custom-input-text>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                  <app-custom-autocomplete formControlName="mechanicId" [labelText]="'Mecánico'" [list]="listMechanic"
                    [required]="true"></app-custom-autocomplete>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-4 col-6">
                  <app-custom-select formControlName="maintenanceTypeId" [labelText]="'Tipo Mtto.'"
                    [list]="listTypeMaintenance" [required]="true"></app-custom-select>
                </div>
                <div class="col-lg-4 col-md-3 col-sm-3 col-6">
                  <app-custom-datetime-picker formControlName="dateInitialMaintenanceOrder"
                    [labelText]="'Fecha Inicial'" (onChangeDate)="changeDateInitial()"></app-custom-datetime-picker>
                </div>
                <div class="col-lg-8 col-md-9 col-sm-9 col-12">
                  <app-custom-textarea formControlName="initialDiagnosis" [labelText]="'Diagnóstico Ini.'"
                    [autoResize]="false" [rows]="3" [maxLength]="500"></app-custom-textarea>
                </div>
                <div class="col-lg-4 col-md-3 col-sm-3 col-6">
                  <app-custom-datetime-picker formControlName="dateFinalMaintenanceOrder" [labelText]="'Fecha Fin'"
                    (onChangeDate)="changeDateFinal($event)"></app-custom-datetime-picker>
                </div>
                <div class="col-lg-8 col-md-9 col-sm-9 col-12">
                  <app-custom-textarea formControlName="finalDiagnosis" [labelText]="'Diagnóstico Fin.'"
                    [autoResize]="false" [rows]="3" [maxLength]="500"></app-custom-textarea>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-3 col-4">
                  <app-custom-input-decimal formControlName="repairHour"
                    [labelText]="'Horas Reparación'"></app-custom-input-decimal>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-3 col-4">
                  <app-custom-input-decimal formControlName="kmHoromValue" [labelText]="'Horómetro/Odómetro'"
                    [required]="equipmentLogbookUnitId == unitHoursId"
                    (onChangeNumber)="changeKmHoromValue($event)"></app-custom-input-decimal>
                </div>
                <div [hidden]="maintenanceOrderClass != scheduledClass" class="col-lg-3 col-md-3 col-sm-3 col-4">
                  <app-custom-select formControlName="maintenancePlan" [labelText]="'Plan mtto.'"
                    [list]="listMaintenancePlans" (onChangeSelect)="onSelectMaintenancePlan($event)"
                    [required]="maintenanceOrderContract.maintenanceOrderClassId  == scheduledClass"></app-custom-select>
                </div>
                <div [hidden]="maintenanceOrderClass != scheduledClass" class="col-lg-3 col-md-3 col-sm-3 col-4">
                  <app-custom-input-text formControlName="interval" [labelText]="'Intervalo'"
                    [disabled]="true"></app-custom-input-text>
                </div>

                <div *ngIf="maintenanceOrderClass == scheduledClass"
                  class="col-lg-6 col-md-6 col-sm-6 col-8 d-flex align-items-end gap-2 mt-2">
                  <app-custom-button [title]="'Actividades'" [label]="'Actividades'" [width]="'7rem'"
                    [icon]="'pi pi-list-check'" [severity]="'success'"
                    (onClick)="openMaintenanceActivitiesModal()"></app-custom-button>
                  <app-custom-modal #maintenanceOrderActivities [label]="'Seleccionar'" [width]="'80vw'"
                    [header]="'Plan de Mantenimiento - ' + maintenanceOrderContract.maintenancePlan" [closable]="true"
                    [inputs$]="inputsForMaintenanceOrderActivitiesModal$" [output$]="output$"
                    [children]="componentMaintenanceOrderActivitiesModal" (params)="reloadMaintenanceOrder($event)"
                    hidden></app-custom-modal>

                  <app-custom-button [title]="'Insumos'" [label]="'Insumos'" [width]="'7rem'" [icon]="'pi pi-box'"
                    [severity]="'success'" (onClick)="openMaintenanceSuppliesModal()"></app-custom-button>
                  <app-custom-modal #maintenanceOrderSupplies [label]="'Seleccionar'" [width]="'80vw'"
                    [header]="'Insumos - Plan Mtto. ' + maintenanceOrderContract.maintenancePlan" [closable]="true"
                    [inputs$]="inputsForMaintenanceOrderSuppliesModal$" [output$]="output$"
                    [children]="componentMaintenanceOrderSuppliesModal" (params)="reloadMaintenanceOrder($event)"
                    hidden></app-custom-modal>
                </div>

                <div class="col-lg-6 col-md-6 col-sm-6 col-12 d-flex align-items-end justify-content-end mt-2">
                  <app-custom-button [title]="'Guardar O.M.'" [label]="'Guardar'" [disabled]="disabledForm"
                    (onClick)="onSave()"></app-custom-button>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-5 col-12">
            <div class="row d-flex justify-content-end">
              <div class="row col-lg-10">
                <div [hidden]="devolutionConsecutive == ''" [class.d-flex]="devolutionConsecutive != ''"
                  class="col-auto align-items-end animate-fade-in">
                  <app-custom-chip [link]="devolutionId ? ['/devolution/register', devolutionId] : null"
                    tooltip="Ver devolución" [label]="'Devolución: ' + devolutionConsecutive" />
                </div>
                <div [hidden]="suspensionConsecutive == ''" [class.d-flex]="suspensionConsecutive != ''"
                  class="col-auto align-items-end animate-fade-in">
                  <app-custom-chip [link]="['/suspension/register', suspensionId]" tooltip="Ver suspensión"
                    [label]="'Suspensión: ' + suspensionConsecutive" />
                </div>
                <div class="col-lg-5 col-md-6 col-sm-6 col-12">
                  <app-custom-input-text [value]="noteStageCurrent" [disabled]="true"
                    [labelText]="'Etapa'"></app-custom-input-text>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-4 col-12 d-flex align-items-end">
                  <app-custom-button [title]="'Notas / Etapas'" [label]="'Notas / Etapas'" [icon]="'pi pi-clipboard'"
                    [width]="'8rem'" (onClick)="openNotesModal()"></app-custom-button>
                  <app-custom-modal #selectNoteStage [label]="'Seleccionar'" [header]="'Notas / Etapas'"
                    [closable]="false" [inputs$]="inputsForModals$" [output$]="output$"
                    [children]="componentNoteStageModal" (params)="reloadMaintenanceOrder($event)"
                    hidden></app-custom-modal>
                </div>
                <div [hidden]="maintenanceOrderClass != siteClass" class="col-lg-12 col-md-12 col-sm-12 col-12">
                  <fieldset class="border p-2 mt-2">
                    <div class="row">
                      <div class="col-lg-6 col-md-3 col-sm-6 col-12">
                        <app-custom-input-text formControlName="reportedBy" [labelText]="'Reportado por'"
                          [maxLength]="50"></app-custom-input-text>
                      </div>
                      <div class="col-lg-6 col-md-3 col-sm-6 col-12">
                        <app-custom-input-text formControlName="receivedBy" [labelText]="'Recibido por'"
                          [maxLength]="50"></app-custom-input-text>
                      </div>
                      <div class="col-lg-6 col-md-3 col-sm-6 col-12">
                        <app-custom-input-text formControlName="contactConstructionSite" [labelText]="'Contacto obra'"
                          [maxLength]="50"></app-custom-input-text>
                      </div>
                      <div class="col-lg-4 col-md-2 col-sm-3 col-6">
                        <app-custom-datepicker formControlName="dateCompromise" [labelText]="'Compromiso'"
                          [required]="maintenanceOrderContract.maintenanceOrderClassId  == siteClass"></app-custom-datepicker>
                      </div>
                    </div>
                  </fieldset>
                </div>
                <div class="col-lg-12 col-md-12 col-sm-12 col-12">
                  <fieldset class="border p-2 mt-2">
                    <div class="row">
                      <div class="col-lg-6 col-md-3 col-sm-6 col-12">
                        <app-custom-autocomplete formControlName="transporterId" [labelText]="'Conductor'"
                          [list]="listDriver"></app-custom-autocomplete>
                      </div>
                      <div class="col-lg-6 col-md-3 col-sm-6 col-12">
                        <app-custom-autocomplete formControlName="vehicleId" [labelText]="'Vehiculo'"
                          [list]="listVehicle"></app-custom-autocomplete>
                      </div>
                      <div class="col-lg-4 col-md-2 col-sm-3 col-6">
                        <app-custom-input-decimal formControlName="transportValue"
                          [labelText]="'Vr.Trans a cobrar'"></app-custom-input-decimal>
                      </div>
                      <div class="col-lg-4 col-md-2 col-sm-3 col-6">
                        <app-custom-input-decimal formControlName="transportValueToPay"
                          [labelText]="'Vr.Trans a pagar'"></app-custom-input-decimal>
                      </div>
                    </div>
                  </fieldset>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                  <fieldset class="border p-2 mt-2">
                    <legend>Reparaciones - Costos</legend>
                    <div class="row">
                      <div class="col-lg-8 col-md-5 col-sm-6 col-6">
                        <app-custom-input-decimal formControlName="costRepairValue"
                          [labelText]="'Vr.Costos'"></app-custom-input-decimal>
                      </div>
                      <div class="col-lg-4 col-md-4 col-sm-4 col-6 d-flex align-items-end gap-1">
                        <app-custom-button [title]="'Reparaciones'" [icon]="'pi pi-pencil'"
                          (onClick)="openRepairsModal()"></app-custom-button>
                        <app-custom-modal #addRepair [label]="'Seleccionar'" [header]="'Reparaciones - Costos'"
                          [inputs$]="inputsForModals$" [output$]="output$" [children]="componentRepairModal" hidden
                          [closable]="false" (params)="reloadMaintenanceOrder($event)"></app-custom-modal>
                        <app-custom-button [title]="titleStateVrRepairCost" [icon]="iconStateVrRepairCost"
                          [disabled]="disabledReverseStateBtn" (onClick)="changeCostRepairState()"></app-custom-button>
                      </div>
                    </div>
                  </fieldset>
                </div>
                <div [hidden]="maintenanceOrderClass == scheduledClass" class="col-lg-12 col-md-12 col-sm-12 col-12">
                  <fieldset class="border p-2 mt-2">
                    <legend>Reparaciones - A Facturar</legend>
                    <div class="row">
                      <div class="col-lg-3 col-md-3 col-sm-3 col-6 gap-1 d-flex align-items-end mb-1">
                        <app-custom-checkbox formControlName="swChargeConstructionSite" [labelText]="'Cobro a Obra'"
                          (onChangeCheckBox)="changeSwChargeConstructionSite($event, false)"></app-custom-checkbox>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-lg-4 col-md-4 col-sm-4 col-6 d-flex align-items-end">
                        <app-custom-input-text id="invoiceNumber" formControlName="invoiceNumber"
                          [labelText]="'Nro. Fra.'" [maxLength]="50"></app-custom-input-text>
                        <app-custom-button id="selectInvoiceButton" [title]="'Seleccionar Fra.'"
                          [icon]="'pi pi-external-link'" [severity]="'contrast'"
                          [disabled]="maintenanceOrderContract.swBlock || maintenanceOrderContract.maintenanceOrderStateId == 3"
                          (onClick)="openSelectionInvoiceModal()"></app-custom-button>
                        <app-custom-modal #invoiceSelection [label]="'Seleccionar'" [header]="'Selección de Facturas'"
                          [children]="componentInvoicesSelection" [inputs$]="inputsForInvoicesSelection$"
                          [output$]="outputForInvoices$" (selectedItems)="handleSelectedItem($event)"
                          hidden></app-custom-modal>
                      </div>
                      <div class="col-lg-4 col-md-4 col-sm-4 col-6">
                        <app-custom-input-decimal formControlName="valueToInvoiced"
                          [labelText]="'Vr. Facturado'"></app-custom-input-decimal>
                      </div>
                    </div>
                  </fieldset>
                </div>
                <div [hidden]="maintenanceOrderClass != siteClass" class="col-lg-6 col-md-6 col-sm-6 col-12">
                  <fieldset class="border p-2 mt-2">
                    <legend>Calificación del servicio</legend>
                    <div class="row">
                      <div class="col-lg-7 col-md-7 col-sm-7 col-6">
                        <app-custom-select [labelText]="'Atendido a tiempo'" [list]="listAttendedOnTime"
                          formControlName="swDeliveredOnTime"></app-custom-select>
                      </div>
                      <div class="col-lg-5 col-md-5 col-sm-5 col-6">
                        <app-custom-select [labelText]="'Calificación'" [list]="listServiceRating"
                          formControlName="qualificationId"></app-custom-select>
                      </div>
                    </div>
                  </fieldset>
                </div>
                <div [hidden]="maintenanceOrderClass != scheduledClass" class="col-lg-6 col-md-6 col-sm-6 col-12">
                  <fieldset class="border p-2 mt-2">
                    <legend>Programación de Mtto.</legend>
                    <div class="row">
                      <div class="col-lg-5 col-md-5 col-sm-5 col-6">
                        <app-custom-input-number formControlName="consecutiveMaintenanceScheduling"
                          [labelText]="'Programación'"></app-custom-input-number>
                      </div>
                      <div class="col-lg-7 col-md-7 col-sm-7 col-6">
                        <app-custom-datepicker formControlName="dateMaintenanceScheduling"
                          [labelText]="'Fecha Programación'"></app-custom-datepicker>
                      </div>
                    </div>
                  </fieldset>
                </div>
                <div [hidden]="maintenanceOrderClass != scheduledClass" class="col-lg-6 col-md-6 col-sm-6 col-12">
                  <fieldset class="border p-2 mt-2">
                    <legend>Reprogramada a partir de.</legend>
                    <div class="row">
                      <div class="col-lg-5 col-md-5 col-sm-5 col-6">
                        <app-custom-input-number formControlName="maintenanceOrderOriginConsecutive"
                          [labelText]="'Ord.Mtto.Origen'"></app-custom-input-number>
                      </div>
                    </div>
                  </fieldset>
                </div>
                <div class="col-lg-12 col-md-12 col-12 d-flex gap-1 printBtns">
                  <app-custom-button [title]="'Imprimir OM. en blanco'" [label]="'Imp.OM.enBlanco'"
                    [icon]="'pi pi-print'" [severity]="'secondary'" [width]="'8.5rem'"
                    (onClick)="printMaintenanceOrder(true)">
                  </app-custom-button>
                  <app-custom-button [title]="'Imprimir OM. diligenciada'" [label]="'Imp.OM.Diligenc.'"
                    [icon]="'pi pi-print'" [severity]="'secondary'" [width]="'8.5rem'"
                    (onClick)="printMaintenanceOrder(false)"></app-custom-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</section>
<!-- Mensaje de duplicidad ventanas abiertas -->
<div class="container-form d-flex flex-row text-danger" *ngIf="isOpened">
  <span class="material-icons me-1"> highlight_off </span>
  <h6>No se permite tener dos ventanas/pestañas de {{nameWindow}} abiertas.</h6>
</div>

<!-- Impresion Orden de Mantenimiento en Sitio -->
<app-print-maintenance-order-site *ngIf="maintenanceOrderContract.maintenanceOrderClassId == siteClass"
  id="print-maintenance-order-site" [companyId]="companyId" [printDocument]="true"
  [maintenanceOrderPrintModel]="maintenanceOrderPrintModel" [editFormat]="false" [focusText]="true"
  [reloadPrint]="reloadPrintSite" [onBlank]="printOmOnBlank"
  (finishLoadingPrintMaintenanceOrder)="finishPrintMaintenanceOrder($event)">
</app-print-maintenance-order-site>

<!-- Impresion Orden de Mantenimiento en Taller -->
<app-print-maintenance-order-workshop *ngIf="maintenanceOrderContract.maintenanceOrderClassId == workshopClass"
  id="print-maintenance-order-workshop" [companyId]="companyId" [printDocument]="true"
  [maintenanceOrderPrintModel]="maintenanceOrderPrintModel" [editFormat]="false" [focusText]="true"
  [reloadPrint]="reloadPrintWorkshop" [onBlank]="printOmOnBlank"
  (finishLoadingPrintMaintenanceOrder)="finishPrintMaintenanceOrder($event)">
</app-print-maintenance-order-workshop>

<!-- Impresion Orden de Mantenimiento Programada -->
<app-print-maintenance-order-scheduled *ngIf="maintenanceOrderContract.maintenanceOrderClassId == scheduledClass"
  id="print-maintenance-order-scheduled" [companyId]="companyId" [formatModel]="formatScheduled"
  [maintenanceOrderPrintContract]="maintenanceOrderPrintModel" [editFormat]="false" [focusText]="true"
  [reloadPrint]="reloadPrintScheduled" [onBlank]="printOmOnBlank"
  (finishLoadingPrint)="finishPrintMaintenanceOrder($event)">
</app-print-maintenance-order-scheduled>

<!-- Modal consecutivo inicial (sin registros) -->
<app-custom-modal #initialConsecutive [header]="'Número de documento inicial'"
  [children]="componentInitialConsecutiveModal" [width]="'25rem'" hidden [output$]="outputForInitialConsecutive$">
</app-custom-modal>